import React, { useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { editorConfiguration } from "../../../../utils/ckEditorUtils";
import { DYNAMIC_FIELD_TYPES } from "../../../common/constants";
import NumberFormat from "react-number-format";
import SelectBox from "../../../images/components/SelectBox";
import DatePicker from "react-datepicker";
import ReactTooltip from "react-tooltip";
import Portal from "../../../common/components/Portal";
import { RichEditorPopup } from "../../../common/components/formFields/RichEditorPopup";
import moment from "moment";
import { fieldData } from "../../../assetSurveyProject/components/NewFieldDynamicForm/constants";
import Autosuggest from "react-autosuggest";
import { defaultTheme } from "react-autosuggest/dist/theme";
import { ColorPicker } from "../../../common/components/formFields/ColorPicker";
import CopyToClipboard from "react-copy-to-clipboard";
import { sanitizeHtml } from "../../../common/components/SafeHtml";

export const FormField = ({
    fieldType = "text",
    label,
    fieldKey,
    fieldParam,
    value: data,
    onChange,
    bandShown,
    bandId,
    handleBandClick,
    fieldItem,
    showErrorBorder,
    multiselectClass,
    isFieldLocked,
    isLoading,
    hasEmptyOption = true,
    isMaintenanceYear,
    placeholder,
    isCapitalType,
    tooltip = "",
    isPriority,
    name = "",
    isAsset,
    disabledMessage = {},
    hasRemove = false,
    onRemove,
    hasGroupedByOptions,
    isSurveyAssetField = false,
    isSurveyMultiAssetField = false,
    isManufacturer = false,
    handleInputChange,
    isLoadingDrop = false,
    manufacturerCount = null,
    isCreatable = false,
    createOption,
    isDropdownDynamic = false,
    showInfo = false,
    onInfoClick = null,
    isMobileRecommendation = false,
    toggleCreateDynamicForm,
    suggestionArray = [],
    isStaticField,
    colSize = "",
    hasSuggestionSearch = false,
    hasSuggestionClear = false,
    onBlur,
    hasSearchFunction = false,
    hasDisabledOptions = false,
    hasMaxHeight = "",
    isMultiEdit = false,
    labelAddon = null,
    searchText = ""
}) => {
    const [showRichTextPopup, setShowRichTextPopup] = useState({ value: "", label: "", key: "", onSaveData: () => {}, show: false });
    const [fieldSuggestions, setFieldSuggestions] = useState([]);

    const {
        mandatory = false,
        prefix = "",
        suffix = "",
        thousand_separator = false,
        read_only = false,
        decimal_scale = 0,
        format = null,
        allow_negative = true,
        isFieldError = false,
        has_copy = false,
        isAllowed
    } = fieldItem?.rules || {};
    const isLocked = isFieldLocked && isFieldLocked(fieldKey);
    const isSurveyDetailsField = typeof fieldKey === "string" && fieldKey.startsWith("survey_details.");
    const value = isMaintenanceYear || isPriority || isAsset ? data : (data[fieldParam] ?? "");
    const isError = isFieldError || (showErrorBorder && mandatory && (!value || (value && !value?.toString()?.trim()?.length)));
    const [copySuccess, setCopySuccess] = useState(false);

    const toggleShowRichTextPopup = value => setShowRichTextPopup(value);

    const renderSuggestion = suggestion => <div>{suggestion}</div>;

    const onSuggestionsFetchRequested = ({ value }) => {
        if (hasSuggestionSearch) {
            const firstMatch = value
                ? (suggestionArray || [])?.filter(item => item?.toLowerCase().includes(value?.toLowerCase()))
                : suggestionArray || [];
            setFieldSuggestions(firstMatch);
        } else {
            setFieldSuggestions(suggestionArray);
        }
    };

    const onSuggestionsClearRequested = () => {
        setFieldSuggestions([]);
    };
    const getSuggestionValue = suggestion => suggestion;

    const renderRichTextPopup = () => {
        const { label, key, onSaveData, show, value } = showRichTextPopup;
        if (!show) return null;
        return (
            <Portal
                body={
                    <RichEditorPopup
                        value={value}
                        label={label}
                        key={key}
                        onCancel={() => toggleShowRichTextPopup({ ...showRichTextPopup, show: false })}
                        saveData={onSaveData}
                        isSurveyTemplate={isSurveyAssetField}
                        isReadOnly={read_only}
                    />
                }
                onCancel={() => toggleShowRichTextPopup({ ...showRichTextPopup, show: false })}
            />
        );
    };

    const handleCopy = value => {
        setCopySuccess(value);
        setTimeout(() => {
            setCopySuccess(false);
        }, 2000);
    };
    const renderHighlightedLabel = labelValue => {
        const query = searchText?.trim();
        const labelText = labelValue ?? "";
        if (!query) return labelText;

        return labelText.split(new RegExp(`(${query})`, "ig")).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={`${part}-${index}`} className="asset-field-search-label">
                    {part}
                </span>
            ) : (
                part
            )
        );
    };
    return (
        <div
            className={`${isStaticField ? "mob-asset txt-rcm" : "txt-rcm"} 
              ${fieldItem?.className ?? ""} 
              ${colSize ? `col-md-${colSize} dynamic-cell` : ""}`.trim()}
            key={fieldKey}
        >
            {renderRichTextPopup()}
            <ReactTooltip
                id="form-field"
                effect="solid"
                place="top"
                backgroundColor="#007bff"
                className="rc-tooltip-custom-class"
                html={true}
                getContent={dataTip => (dataTip ? sanitizeHtml(dataTip) : "")}
            />
            <div className="content-inp-card position-relative" {...disabledMessage}>
                <div
                    className={`form-group ${fieldType === DYNAMIC_FIELD_TYPES.MEMO ? "ckeditor-band recom-ck-band " : ""}`}
                    data-target={bandShown?.[bandId] ? `#${bandId}` : "false"}
                    aria-expanded={bandShown?.[bandId] ? true : "false"}
                    onClick={() => handleBandClick(bandId, true)}
                    data-tip={isLocked ? "This field is locked and cannot be edited" : tooltip}
                    data-for="recommendation_details"
                >
                    <label
                        onClick={() => {
                            if (showInfo && onInfoClick) onInfoClick();
                        }}
                    >
                        <span>
                            {renderHighlightedLabel(label)} {mandatory ? "*" : ""}
                            {fieldItem?.tooltip && (isSurveyAssetField || isMobileRecommendation) && (
                                <i data-for="form-field" className="fas fa-info-circle" data-tip={fieldItem?.tooltip} />
                            )}
                        </span>
                        {showInfo && <i data-for="display_formats" className="fas fa-info-circle" />}

                        {fieldItem?.invalid && <span className="new-span-badge mr-2">New</span>}
                        {fieldItem?.invalid && fieldData?.[fieldKey] && fieldData?.[fieldKey]?.permission && toggleCreateDynamicForm && (
                            <button type="button" className="cursor-pointer btn-trade" onClick={() => toggleCreateDynamicForm(fieldKey, value)}>
                                <span> + </span>Create
                            </button>
                        )}
                        {fieldType === DYNAMIC_FIELD_TYPES.MEMO && (
                            <button
                                type="button"
                                class="butn-expansion"
                                data-for="input_field"
                                data-tip="Expand Field"
                                onClick={() =>
                                    toggleShowRichTextPopup({
                                        value: value,
                                        label: label,
                                        key: fieldKey,
                                        onSaveData: value => {
                                            onChange(fieldKey, value);
                                            toggleShowRichTextPopup({ ...showRichTextPopup, value, show: false });
                                        },
                                        show: true
                                    })
                                }
                            >
                                <img src="/img/expand1.svg" alt="" />
                            </button>
                        )}
                        {has_copy && (
                            <CopyToClipboard text={value} onCopy={() => handleCopy(value)}>
                                <span className="icon cursor-hand ai-copy">
                                    {copySuccess === value ? (
                                        <i
                                            className="fa fa-check"
                                            style={{ color: "green" }}
                                            data-tip="Copied to Clipboard"
                                            data-for="form-field"
                                            data-place="top"
                                        />
                                    ) : (
                                        <i
                                            className="fa fa-copy"
                                            data-tip="Click to Copy Value"
                                            data-for="form-field"
                                            data-place="top"
                                            style={{ color: "#4B90FA" }}
                                        />
                                    )}
                                </span>
                            </CopyToClipboard>
                        )}
                        {labelAddon}
                    </label>

                    {fieldType === DYNAMIC_FIELD_TYPES.TEXT ? (
                        (!isSurveyAssetField && !isSurveyMultiAssetField) || isSurveyDetailsField ? (
                            <input
                                type="text"
                                autoComplete={"off"}
                                className={`custom-input form-control ${read_only ? "cursor-diabled" : ""} ${isError ? "error-border" : ""} ${
                                    isLocked ? "grayed-out" : ""
                                } ${multiselectClass && multiselectClass(fieldParam)}`}
                                placeholder={label}
                                value={value}
                                disabled={read_only || isLocked}
                                name={name || fieldParam}
                                onChange={onChange}
                                onBlur={() => {
                                    if (onBlur) onBlur();
                                }}
                            />
                        ) : (
                            <>
                                <Autosuggest
                                    suggestions={fieldSuggestions}
                                    onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                    onSuggestionsClearRequested={onSuggestionsClearRequested}
                                    inputProps={{
                                        value: value ?? "",
                                        className: `custom-input form-control ${read_only ? "cursor-diabled" : ""} ${isError ? "error-border" : ""} ${
                                            isLocked ? "grayed-out" : ""
                                        } ${multiselectClass && multiselectClass(fieldParam)}`,
                                        onChange: (e, { newValue }) => {
                                            onChange({ target: { value: newValue } });
                                        },
                                        placeholder: label,
                                        disabled: read_only || isLocked,
                                        onBlur: () => {
                                            if (onBlur) onBlur();
                                        }
                                    }}
                                    renderSuggestion={renderSuggestion}
                                    getSuggestionValue={getSuggestionValue}
                                    shouldRenderSuggestions={() => true}
                                    theme={{
                                        ...defaultTheme,
                                        container: `${
                                            suggestionArray?.length && !hasSuggestionClear ? "dropdown-arrow-icon" : ""
                                        } react-autosuggest__container `
                                    }}
                                />
                                {hasSuggestionClear ? (
                                    <i className="fas fa-times cursor-pointer recom-close-icon" onClick={() => onChange(fieldKey, "")}></i>
                                ) : null}
                            </>
                        )
                    ) : [DYNAMIC_FIELD_TYPES.SELECT, "custom_select"].includes(fieldType) ? (
                        <div
                            className={`sel-recom-react ${fieldItem?.invalid ? "new-badge-highlighter" : ""} ${
                                multiselectClass && multiselectClass(fieldParam)
                            }`}
                        >
                            <SelectBox
                                className={`selectOtr not-draggable build-select-otr ${isLocked ? "grayed-out" : ""}`}
                                optionsList={
                                    isPriority
                                        ? (fieldItem?.field_options ?? []).map((option, idx) => ({
                                              ...option,
                                              description: option.description || ``
                                          }))
                                        : (fieldItem?.field_options ?? [])
                                }
                                name={name || fieldParam}
                                disabled={read_only || isLocked}
                                value={value ?? ""}
                                handleChange={onChange}
                                showErrorBorder={isError}
                                isBuilding={label === "Building"}
                                isRecommendation
                                isCapitalType={isCapitalType}
                                hasEmptySelect={hasEmptyOption}
                                isClearable={false}
                                isLoading={isLoading}
                                isManufacturer={isManufacturer}
                                handleInputChange={handleInputChange}
                                isAsset={isAsset}
                                isLoadingDrop={isLoadingDrop}
                                manufacturerCount={manufacturerCount}
                                isCreatable={isCreatable}
                                createOption={createOption}
                                hasGroupedByOptions={hasGroupedByOptions}
                                isSurveyAssetField={isSurveyAssetField || isSurveyMultiAssetField}
                                isDropdownDynamic={isDropdownDynamic}
                                isMobileRecommendation={isMobileRecommendation ?? false}
                                hasSearchFunction={hasSearchFunction}
                                keyItem={fieldKey}
                                isPriority={isPriority}
                                isRecommendationForm={!isMobileRecommendation && !isAsset && !isSurveyAssetField && !isSurveyMultiAssetField}
                                hasDisabledOptions={hasDisabledOptions}
                                hasMaxHeight={hasMaxHeight}
                            />
                        </div>
                    ) : fieldType === DYNAMIC_FIELD_TYPES.NUMBER ? (
                        <NumberFormat
                            autoComplete={"off"}
                            className={`form-control ${read_only ? "cursor-diabled" : ""} ${isError ? "error-border" : ""} ${
                                isLocked ? "grayed-out" : ""
                            } ${multiselectClass && multiselectClass(fieldParam)}`}
                            placeholder={placeholder || label}
                            thousandSeparator={thousand_separator}
                            prefix={prefix}
                            suffix={suffix}
                            decimalScale={decimal_scale}
                            value={value ?? ""}
                            format={format}
                            disabled={isLocked || read_only}
                            displayType={"input"}
                            allowNegative={allow_negative}
                            onValueChange={values => {
                                if (values?.value !== value && onChange) {
                                    onChange(values);
                                }
                            }}
                            onBlur={() => {
                                if (onBlur) onBlur();
                            }}
                            isAllowed={isAllowed ? isAllowed : undefined}
                        />
                    ) : fieldType === DYNAMIC_FIELD_TYPES.DATE ? (
                        isStaticField ? (
                            <input
                                type="text"
                                autoComplete={"off"}
                                className={`custom-input form-control ${read_only ? "cursor-diabled" : ""}`}
                                placeholder={label}
                                value={moment(value).isValid() ? moment(value).format("MM-DD-YYYY h:mm A") : "-"}
                                disabled={read_only || isLocked}
                                name={name || fieldParam}
                                onBlur={() => {
                                    if (onBlur) onBlur();
                                }}
                            />
                        ) : (
                            <DatePicker
                                autoComplete={"nope"}
                                placeholderText="MM/DD/YYYY"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="scroll"
                                maxDate={moment().add(100, "years").toDate()}
                                minDate={moment().subtract(100, "years").toDate()}
                                className={`custom-input form-control ${multiselectClass && multiselectClass(fieldParam)} ${
                                    isError ? "error-border" : ""
                                }`}
                                selected={value ? (moment(value).isValid() ? moment(value).toDate() : "") : ""}
                                onChange={onChange}
                            />
                        )
                    ) : fieldType === DYNAMIC_FIELD_TYPES.BOOLEAN ? (
                        <div className={`sel-recom-react ${multiselectClass && multiselectClass(fieldParam)}`}>
                            <SelectBox
                                className={`selectOtr not-draggable build-select-otr ${isLocked ? "grayed-out" : ""}`}
                                value={value ?? ""}
                                disabled={read_only || isLocked}
                                handleChange={value => onChange(fieldKey, value)}
                                optionsList={
                                    isMobileRecommendation
                                        ? [
                                              { label: "Yes", value: "Yes" },
                                              { label: "No", value: "No" }
                                          ].map(e => ({ name: e.label, id: e.value }))
                                        : [
                                              { label: "Yes", value: true },
                                              { label: "No", value: false }
                                          ].map(e => ({ name: e.label, id: e.value }))
                                }
                                isClearable={false}
                                showErrorBorder={isError}
                                hasEmptySelect
                                isRecommendation
                                isBoolean
                                isMobileRecommendation={isMobileRecommendation ?? false}
                            />
                        </div>
                    ) : fieldType === DYNAMIC_FIELD_TYPES.MEMO ? (
                        <div
                            className={`form-control ${read_only ? "cursor-disabled" : ""} ${isError ? "error-border" : ""} ${
                                multiselectClass ? multiselectClass(fieldKey) : ""
                            } ${isLocked ? "grayed-out" : ""}`}
                        >
                            <CKEditor
                                editor={Editor}
                                config={{ ...editorConfiguration, toolbar: [] }}
                                id="report-note-template"
                                data={value ?? ""}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    if (!isSurveyMultiAssetField || value !== undefined) {
                                        onChange(fieldKey, data);
                                    }
                                }}
                                onReady={editor => {
                                    if (editor) {
                                        // editor.setData(value || "");
                                    }
                                    if (read_only) {
                                        editor?.enableReadOnlyMode("my-feature-id");
                                    }
                                }}
                                onBlur={() => {
                                    if (onBlur) onBlur();
                                }}
                            />
                        </div>
                    ) : fieldType === DYNAMIC_FIELD_TYPES.CURRENCY ? (
                        <NumberFormat
                            autoComplete={"off"}
                            className={`form-control ${read_only ? "cursor-diabled" : ""} ${isError ? "error-border" : ""} ${
                                multiselectClass ? multiselectClass(fieldParam) : ""
                            } ${isLocked ? "grayed-out" : ""}`}
                            placeholder={label}
                            thousandSeparator={true}
                            prefix={"$ "}
                            decimalScale={decimal_scale}
                            allowNegative={allow_negative}
                            suffix={suffix}
                            value={value || ""}
                            disabled={read_only || isLocked}
                            displayType={"input"}
                            onValueChange={values => {
                                let { floatValue } = values;

                                if (isSurveyAssetField || isSurveyMultiAssetField) {
                                    floatValue = values?.value;
                                }
                                if (values?.value !== value && onChange) {
                                    onChange(fieldKey, floatValue);
                                }
                            }}
                            onBlur={() => {
                                if (onBlur) onBlur();
                            }}
                        />
                    ) : fieldType === DYNAMIC_FIELD_TYPES.COLOR ? (
                        <ColorPicker
                            className={`${read_only ? "cursor-diabled" : ""} ${isError ? "error-border" : ""} ${
                                multiselectClass ? multiselectClass(fieldParam) : ""
                            } ${isLocked ? "grayed-out" : ""}`}
                            color={value || ""}
                            onChange={onChange}
                            isMultiEdit={isMultiEdit}
                        />
                    ) : null}
                    {isMaintenanceYear && hasRemove && (
                        <button className="btn-remove-rec btn-abs-top" data-tip={"Remove Year"} data-for="form-field" onClick={() => onRemove()}>
                            <i className="far fa-trash-alt" />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
